// extracted by mini-css-extract-plugin
export default {"sliderComponent":"slider_sliderComponent__5TteX","sliderComponent_input":"slider_sliderComponent_input__371+-","sliderComponent_range":"slider_sliderComponent_range__mjCKF"};